export const FACET_ADDED = 'FACET_ADDED';
export const FACET_REMOVED = 'FACET_REMOVED';
export const FACET_SHOW_ALL = 'FACET_SHOW_ALL';
export const FACET_RESET = 'FACET_RESET';
export const FACET_SEARCH_WITH_AREA_FILTER = 'FACET_SEARCH_WITH_AREA_FILTER';
